import React, { useState, useEffect } from 'react';
import { NavLink } from 'react-router-dom';
import type { NavItem } from '../../types';

const navItems: NavItem[] = [
  { id: "cold-leads", icon: "📡", label: "Cold Leads" },
  { id: "warm-leads", icon: "💬", label: "Warm Leads" },
  { id: "contacts", icon: "👥", label: "Contacts" },
  { id: "settings", icon: "⚙️", label: "Settings" },
];

export default function Sidebar(): React.JSX.Element {
  const [time, setTime] = useState<Date>(new Date());

  useEffect(() => {
    const interval = setInterval(() => setTime(new Date()), 60000);
    return () => clearInterval(interval);
  }, []);

  return (
    <div className="w-60 bg-dx-surface border-r border-dx-border flex flex-col flex-shrink-0 h-screen sticky top-0">
      {/* Logo */}
      <div className="px-5 py-6 border-b border-dx-border">
        <div className="flex items-center gap-2.5">
          <div className="w-9 h-9 rounded-[10px] flex items-center justify-center text-lg shadow-[0_4px_20px_rgba(37,211,102,0.25)] bg-[linear-gradient(135deg,#25D366,#1BA350)]">
            ⚡
          </div>
          <div>
            <div className="text-lg font-bold text-dx-text tracking-tight">Digitix</div>
            <div className="text-[10px] text-dx-dim font-medium tracking-[1.5px] uppercase">
              Contact Center
            </div>
          </div>
        </div>
      </div>

      {/* Nav */}
      <nav className="flex-1 px-2.5 py-3 flex flex-col gap-0.5">
        {navItems.map(item => (
          <NavLink
            key={item.id}
            to={`/${item.id}`}
            className={({ isActive }) =>
              [
                "flex items-center gap-2.5 px-3.5 py-2.5 rounded-[10px] text-[13px] text-left transition-all duration-150 no-underline",
                isActive
                  ? "font-semibold text-dx-accent bg-[rgba(37,211,102,0.15)] border-l-2 border-dx-accent"
                  : "font-normal text-dx-muted border-l-2 border-transparent hover:bg-[#1A1A25]",
              ].join(" ")
            }
          >
            <span className="text-base w-6 text-center">{item.icon}</span>
            {item.label}
          </NavLink>
        ))}
      </nav>

      {/* Bottom */}
      <div className="p-4 border-t border-dx-border">
        <div className="p-3.5 rounded-xl bg-dx-bg border border-dx-border">
          <div className="flex items-center gap-2 mb-2">
            <div className="w-1.5 h-1.5 rounded-full bg-dx-accent animate-pulse-dot" />
            <span className="text-xs font-semibold text-dx-accent">4 agents online</span>
          </div>
          <div className="text-[11px] text-dx-dim">
            {time.toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" })} · 284 active chats
          </div>
        </div>
      </div>
    </div>
  );
}
